/**
 * 返回上一页
 */


function to(path, obj) {
  console.log(path)
  this.$router.push({ path: path, query: obj })
}

/**
 * 获取多选选中项
 */
function checkBox(data) {
  var arr = [];
  for (var i = 0; i < data.length; i++) {
    if (data[i].checked == '1') {
      arr.push(data[i].id)
    }
  }
  return arr
};


/**
 * 时间格式化
 */
function dateFormat(fmt, date) {
  let ret;
  const opt = {
    "Y+": date.getFullYear().toString(),        // 年
    "m+": (date.getMonth() + 1).toString(),     // 月
    "d+": date.getDate().toString(),            // 日
    "H+": date.getHours().toString(),           // 时
    "M+": date.getMinutes().toString(),         // 分
    "S+": date.getSeconds().toString()          // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
    };
  };
  return fmt;
}



// 数据拷贝
function dataCopy(data) {
  var obj = {};
  obj = JSON.parse(JSON.stringify(data));
  return obj
}

// 下载图片
function downloadImg(imgsrc, name) {
  //下载图片地址和图片名
  var image = new Image()
  // 解决跨域 Canvas 污染问题
  image.setAttribute('crossOrigin', 'anonymous')
  image.onload = function () {
    var canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    var context = canvas.getContext('2d')
    context.drawImage(image, 0, 0, image.width, image.height)
    var url = canvas.toDataURL('image/png') //得到图片的base64编码数据
    var a = document.createElement('a') // 生成一个a元素
    var event = new MouseEvent('click') // 创建一个单击事件
    a.download = name || '绑定二维码' // 设置图片名称
    a.href = url // 将生成的URL设置为a.href属性
    a.dispatchEvent(event) // 触发a的单击事件
  }
  image.src = imgsrc
}

export default {
  checkBox,
  dateFormat,
  dataCopy,
  downloadImg
}


// WEBPACK FOOTER //
// ./src/assets/js/tools.js